"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withProvider = exports.withKey = void 0;
var signers_1 = require("./signers");
function withKey(signer, fn) {
    var publicKey = fn(signer);
    Object.defineProperty(signer, 'publicKey', {
        get: function () { return publicKey; },
    });
    return signer;
}
exports.withKey = withKey;
function withProvider(signer, provider) {
    return new signers_1.ConnectedSigner(signer, provider);
}
exports.withProvider = withProvider;
//# sourceMappingURL=prototypes.js.map